const AboutUsShimmer = () => {
  return (
    <div className="h-96 w-auto overflow-hidden rounded-md shadow-lg bg-slate-300 flex justify-center my-9 mx-auto "></div>
  );
};
export default AboutUsShimmer;
